// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PyCu2","comment":"styles_comment__3HZb4"};